module.exports = __webpack_public_path__ + "si.svg?fdc1ceeae23c149deb2006431d51737a";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/si.svg
// module id = 1354
// module chunks = 0